import React from 'react'
import { fromNow } from '../../../Utils';

function Information({ products, comments, user }) {


    return (
        <div className="profile-info">
            <div className="profile-img">
                <div className="img-cont">
                    <img src={user.meta_data && user.meta_data.profile} />
                </div>
            </div>
            <h5>{user.name}</h5>
            <span className='light-text'>  عضویت : {fromNow(user.created_at)}</span>
            {products && <span className='light-text'>{products.length} <span>آگهی</span></span>}
            <div className="stars">
                <div className="d-flex justify-content-center align-items-center">
                    {user.score && <>
                        {
                            user.score.map(() => {
                                return (<i className="fas fa-star"></i>)
                            })
                        }
                        <span>{comments && comments.length} نفر</span>
                    </>
                    }
                </div>
            </div>
        </div>
    )
}


export default Information